import {
  all,
  fork
} from 'redux-saga/effects';
import configSagas from './config';
import coverageSagas from './coverage';

export default function* rootSaga() {
  yield all([
    fork(configSagas),
    fork(coverageSagas),
  ]);
}


// WEBPACK FOOTER //
// ./src/sagas/index.js